import { FormikProps } from "formik";
import * as React from "react";

export interface IFormikStateProps extends FormikProps<any> {
}

export const DisplayFormikState = (props: IFormikStateProps) =>
  <div style={{ margin: '1rem 0', background: '#f6f8fa', padding: '.5rem', fontSize: '1.2rem' }}>
    <strong>Injected Formik props (the form's state)</strong>
    <div style={{}}>
      <code>touched:</code> {JSON.stringify(props.touched, null, 2)}
    </div>
    <div>
      <code>errors:</code> {JSON.stringify(props.errors, null, 2)}
    </div>
    <div>
      <code>values:</code> {JSON.stringify(props.values, null, 2)}
    </div>
    <div>
      <code>isSubmitting:</code> {JSON.stringify(props.isSubmitting, null, 2)}
    </div>
  </div>;